import React, {createRef, useState, useContext, useEffect, useCallback, useRef} from 'react';
import { useQueryClient } from 'react-query';
import { DragDropContext, Droppable, Draggable } from '@react-forked/dnd';
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import __ from "lodash";
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import SystemContext from "../../../SystemContext";
import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import {MaskedNumber, MaskedText, DatePicker} from '../../../controls';
import { useTheme } from '@material-ui/core';

const formatChars={
  "U": "[A-Za-z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "n": "-",
  "x": "."
}
const today = moment().toISOString();
const dateFormat = "DD/MM/YYYY";

const SectionHeading = (props) => {
  const { children, ...other } = props;
  return (
    <div style={{marginTop: 10, marginBottom: 2, textAlign: "left", fontSize: "14px", fontWeight: "bold", ...other}}>
      {children}
    </div>
  );
}

const ContractRoutesEditor = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  const {record, readOnly, validFrom, validTo, classes} = props;

  useEffect(()=> {
    const addRoute = async () => {
      if (eventBus)
        eventBus.trigger("AddContractDialog.clearRouteSelected");
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
  }
    if (eventBus) {
      eventBus.bind('ContractRoutesEditor.addRoute', addRoute);
      return () => {
        eventBus.unbind("ContractRoutesEditor.addRoute", addRoute);
      }
    }

  }, [eventBus, tableRef]);

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  //const contractRoutes = __.cloneDeep(record.routes);
  const contractRoutes = record.routes;

  const payloadHeaderStyle = { padding: "2px 2px", backgroundColor: "rgb(214, 214, 214)", textAlign: "center" };

  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.id >= 0) {
      if (eventBus) {
        eventBus.trigger('AddContractDialog.routeSelected', rowData);
      }
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "2px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    // const validatorColumn = ValidatorColumn(CostingSectorsValidator, false);

    return [
      // {...validatorColumn, resizable: false},
      {
        ...baseColumn,
        ...ColumnWidth(100,[5,2],undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Route Type",
        field: "sectorType",
        initialEditValue: "",
        lookup: {
          KG: "Per Kilo",
          BASE: "Base",
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(100,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Route",
        field: "sectorName",
        initialEditValue: "",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(50)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(60,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
      //   title: "Day",
      //   field: "day",
      //   type: "numeric",
      //   emptyValue: null,
      //   initialEditValue: null,
      //   editComponent: (props) => (
      //     <MaskedNumber
      //       mask={"d".repeat(1)}
      //       formatChars={formatChars}
      //       maskChar={""}
      //       value={props.value}
      //       decimalScale={0}
      //       onChange={props.onChange}
      //       style={{ fontSize: "0.875rem", textAlign: "right" }}
      //     />
      //   ),
      //   render: (props) => (
      //     <MaskedNumber
      //       displayType="text"
      //       value={props.day}
      //       decimalScale={0}
      //     />
      //   )
      // },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(100,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
      //   title: "Commodity",
      //   field: "commodity",
      //   initialEditValue: "",
      //   editComponent: (props) => (
      //     <MaskedText
      //       mask={"x".repeat(50)}
      //       maskChar={""}
      //       alwaysShowMask={false}
      //       formatChars={formatChars}
      //       value={props.value}
      //       onChange={props.onChange}
      //       inputProps={defaultEditProps}
      //     />
      //   )
      // },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Base Fuel Date",
        field: "baseFuelDate",
        type: "date",
        emptyValue: today,
        initialEditValue:validFrom,
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Base Rate Date",
        field: "baseRateDate",
        type: "date",
        emptyValue: today,
        initialEditValue:validFrom,
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Base Rate",
        field: "baseRate",
        type: "numeric",
        emptyValue: null,
        initialEditValue: null,
        editComponent: (props) => (
          <MaskedNumber
            value={props.value}
            decimalScale={2}
            fixedDecimalScale={true}
            onChange={props.onChange}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        ),
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.baseRate}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Minimum Amount",
        field: "minimumAmount",
        type: "numeric",
        emptyValue: null,
        initialEditValue: null,
        editComponent: (props) => (
          <MaskedNumber
            value={props.value}
            decimalScale={5}
            fixedDecimalScale={true}
            onChange={props.onChange}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        ),
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.minimumAmount}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Pivot Rate",
        field: "overPivotRate",
        type: "numeric",
        emptyValue: null,
        initialEditValue: null,
        editComponent: (props) => (
          <MaskedNumber
            value={props.value}
            decimalScale={2}
            fixedDecimalScale={true}
            onChange={props.onChange}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        ),
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.overPivotRate}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(80,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Rounding",
        field: "roundingMethod",
        initialEditValue: "ROUND",
        lookup: {
          "ROUND": "Default",
          "CEIL": "Ceiling",
          "FLOOR": "Floor",
          "NEXT CENT": "Next Cent",
        },
      },
      {
        ...baseColumn,
        ...ColumnWidth(70,2,undefined,undefined,baseColumn.headerStyle,undefined,false),
        title: "Usable Payload",
        field: "usablePayload",
        type: "numeric",
        emptyValue: null,
        initialEditValue: 100000,
        editComponent: (props) => (
          <MaskedNumber
            value={props.value}
            decimalScale={0}
            fixedDecimalScale={false}
            onChange={props.onChange}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        ),
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.usablePayload}
            decimalScale={0}
            fixedDecimalScale={false}
            inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,payloadHeaderStyle,undefined,false),
        title: "From",
        groupTitle: "Validity",
        field: "validFrom",
        type: "date",
        emptyValue: today,
        initialEditValue:validFrom,
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,payloadHeaderStyle,undefined,false),
        title: "To",
        groupTitle: "Validity",
        field: "validTo",
        type: "date",
        emptyValue: today,
        initialEditValue:validTo,
        editComponent: (props) => (
          <DatePicker
            // minDate={today}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={props.onChange}
          />
        )
      },

      // {
      //   ...baseColumn,
      //   ...ColumnWidth(95,2,undefined,undefined,payloadHeaderStyle,undefined,"NONE"),
      //   groupTitle: "Payload",
      //   title: "Remaining",
      //   field: "payloadRemaining",
      //   type: "numeric",
      //   editable: false,
      //   render: (rowData, rowType, updatedData ) => {
      //     if (getRowIndex(rowData||updatedData||{}) < 1) {
      //       return (<>--</>)
      //     }
      //     return (
      //       <MaskedNumber
      //         displayType="text"
      //         defaultValue={0}
      //         value={rowData.payloadRemaining||0}
      //         decimalScale={0}
      //         fixedDecimalScale={true}
      //         valueCap={props.weightUom==="TON"?150:150000}
      //         suffix={props.weightUom==="TON"?" tons":" kg"}
      //         inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
      //         style={{ fontSize: "0.875rem", textAlign: "right" }}
      //       />
      //     )
      //   }
      // },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(95,2,undefined,undefined,payloadHeaderStyle,undefined,false),
      //   groupTitle: "Payload",
      //   title: "Uplifted",
      //   field: "payloadUp",
      //   type: "numeric",
      //   editable: false,
      //   render: (rowData) => (
      //     <MaskedNumber
      //       displayType="text"
      //       defaultValue={rowData.payloadUp||0}
      //       value={rowData.payloadUp||0}
      //       decimalScale={0}
      //       fixedDecimalScale={true}
      //       valueCap={props.weightUom==="TON"?150:150000}
      //       suffix={props.weightUom==="TON"?" tons":" kg"}
      //       inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
      //       style={{ fontSize: "0.875rem", textAlign: "right" }}
      //     />
      //   )
      // },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(95,2,undefined,undefined,payloadHeaderStyle,undefined,"NONE"),
      //   groupTitle: "Payload",
      //   title: "Onboard",
      //   field: "payloadOnboard",
      //   type: "numeric",
      //   editable: false,
      //   render: (rowData, rowType, updatedData ) => (
      //     <MaskedNumber
      //       displayType="text"
      //       defaultValue={0}
      //       value={rowData.payloadOnboard}
      //       decimalScale={0}
      //       fixedDecimalScale={true}
      //       valueCap={props.weightUom==="TON"?150:150000}
      //       suffix={props.weightUom==="TON"?" tons":" kg"}
      //       inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
      //       style={{ fontSize: "0.875rem", textAlign: "right" }}
      //     />
      //   ),
      // },
      // {
      //   ...baseColumn,
      //   ...ColumnWidth(95,2,undefined,undefined,payloadHeaderStyle,undefined,false),
      //   groupTitle: "Payload",
      //   title: "Unloaded",
      //   field: "payloadOff",
      //   type: "numeric",
      //   editable: false,
      //   render: (rowData) => (
      //     <MaskedNumber
      //       displayType="text"
      //       defaultValue={rowData.payloadOff}
      //       value={rowData.payloadOff}
      //       decimalScale={0}
      //       fixedDecimalScale={true}
      //       valueCap={rowData.payloadOnboard}
      //       suffix={props.weightUom==="TON"?" tons":" kg"}
      //       inputProps={{ style:{ fontSize: "0.875rem", textAlign: "right" }}}
      //       style={{ fontSize: "0.875rem", textAlign: "right" }}
      //     />
      //   )
      // },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.contractRoutesEditor}>
          <SectionHeading>Contract Routes</SectionHeading>
          <MaterialTable
            tableRef={tableRef}
            data={contractRoutes}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            onRowClick={handleRowClick}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              onEditModeChanged: (editMode)=> {
                if (props.changeButtonState) {
                  const changes = {
                    save: {disabled: false, hidden: false},
                  }
                  if (editMode) {
                    changes['save'] = {disabled: true, hidden: false}
                  }
                  debugger;
                  props.changeButtonState(changes);
                }
              },
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                     <MaterialTableBody
                      {...props}
                      ref={bodyRef}
                      rowHeight={39}
                      overscanRowCount={10}
                      // addVirtualScrolling={true}
//                      bodyHeight={300}
                      extraEditHeight={46}
                      headerHeight={46}
                    />
              ),
              Row: (props) => (
                <MaterialTableBodyRow {...props} />
              ),
            }}
            actions={[]}
            title="Contract Routes"
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: () => {
                return state.canEdit && !readOnly;
              },
              isDeletable: () => {
                return state.canEdit && !readOnly;
              },
              onRowAdd: state.canEdit && !readOnly
                ? (newData) => new Promise((resolve, reject) => {
                  if (Array.isArray(contractRoutes)) {
                    const newRoute = {...newData, fuelAnnexSectorUuid: uuidv4(), fuelAnnexUuid: record.fuelAnnexUuid};
                    contractRoutes.push(newRoute);
                    props.onChange({routes: contractRoutes, resolve, reject});
                  } else {
                    reject();
                  }
                })
                : undefined,
              onRowUpdate: state.canEdit && !readOnly
              ?(newData, oldData) =>
                new Promise((resolve, reject) => {
                  const sectorIdx = __.findIndex(contractRoutes, (trip) => {
                    const tripData = __.omit(trip, ["tableData"]);
                    const oldRecord = __.omit(oldData, ["tableData"]);
                    return __.isEqual(tripData, oldRecord);
                  });
                  if (sectorIdx >= 0) {
                    contractRoutes[sectorIdx] = {...newData};
                    props.onChange({routes: contractRoutes, resolve, reject});
                  } else {
                    reject();
                  }
                })
                : null,
              onRowDelete: state.canEdit && !readOnly
              ?(oldData) =>
                new Promise((resolve, reject) => {
                  const sectorIdx = __.findIndex(contractRoutes, (trip) => {
                    const tripData = __.omit(trip, ["tableData"]);
                    const oldRecord = __.omit(oldData, ["tableData"]);
                    return __.isEqual(tripData, oldRecord);
                  });
                  if (sectorIdx >= 0) {
                    contractRoutes.splice(sectorIdx, 1);
                    props.onChange({routes: [...contractRoutes], resolve, reject});
                  } else {
                    reject();
                  }
                })
                :null,
            }}
        />
      </div>
  );
}

export default ContractRoutesEditor;


